import { Image } from "antd";

export default function LogoImage() {
  return (
    <Image preview={false} src="/logo-transparent.png" />
  );
}